<template>
  <div name="demo-table-row-column-style">
    <label class="color-skin align-center">Status Approve Condition</label>
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :indexDisp="true"
                :approveDisp="true"
                :approveBtnDisp="true"
                :approveEvent="approveEvent"
                :detailEvent="detailEvent"
                :nowLang="nowLang" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.approveLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'columnClassCondition', flgRowCondition)
let mockData = mock.dataApprove(flgRowCondition)

export default {
  name: 'demo-table-row-column-style',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  },
  methods: {
    detailEvent (dataRow) {
      console.log('Detail Event')
    },
    approveEvent (dataRow) {
      console.log('Approve Event')
    },
    rowDisableCondition (dataRow) {
      return dataRow.rowID % 3 > 0
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableRowColumnStyle.vue?bf63dd30